import { create } from 'zustand'
import { devtools } from 'utils/devtools'
import { immer } from 'zustand/middleware/immer'

type OrderConfigureState = {
  isPending: boolean
  submitError: string | null
}

type OrderConfigureActions = {
  setPending: (isPending: boolean) => void
  setSubmitError: (error: string | null) => void
}

const initialState: OrderConfigureState = {
  isPending: false,
  // only used for debugging for now
  submitError: null,
}

export const useOrderConfigureState = create<
  OrderConfigureState & OrderConfigureActions
>()(
  devtools(
    immer((set) => ({
      ...initialState,
      setPending: (isPending) =>
        set((state) => {
          state.isPending = isPending
        }),
      setSubmitError: (error) =>
        set((state) => {
          state.submitError = error
        }),
    })),
    {
      name: 'order-configure-state',
    }
  )
)
